<template>
  <div>
    <SysBotao
      id="btn-finalizar-compra"
      class="font-16"
      :class="{'cursor-no-drop': desabilitar}"
      color-texto="white"
      background="#219653"
      radius="8"
      @click="abrirDialogGerarCotacao()"
    >
      Gerar exportações
    </SysBotao>

    <v-dialog
      v-model="DIALOG_ATIVO"
      content-class="bar-12"
      width="1400px"
      persistent
      transition="dialog-top-transition"
    >
      <v-card class="px-2">
        <div class="d-flex pl-12 pr-5 pt-3 pb-2">
          <div>
            <p v-text="'Cotação'" class="ma-0 font-24" />
            <p
              id="subtitulo-dialog"
              v-text="'Selecione quais fornecedores e produtos você deseja realizar cotação'"
            />
          </div>

          <v-spacer />

          <div class="d-flex align-center">
            <RelatoriosAutocomplete
              v-model="relatorioSelecionado"
              hide-details
              outlined
              dense
              class="mb-2"
              append-icon="mdi-chevron-down"
            />
          </div>
        </div>

        <v-divider />

        <div class="w-full d-flex px-4" v-if="DIALOG_ATIVO">
          <v-col cols="7" class="pa-0 border-r">
            <FornecedoresPorCotar
              v-model="fornecedores_selecionados"
              :pedido="pedido"
              :dialog_ativo="DIALOG_ATIVO"
              class="mt-5 mr-1"
            />
          </v-col>
          <v-col cols="5">
            <MarcasASeremCotadas v-model="fornecedores_selecionados" class="pa-0 mx-1" />
          </v-col>
        </div>

        <v-divider />

        <div class="d-flex align-center pt-5 pb-6 pr-5">
          <v-spacer />

          <v-checkbox v-model="todos_os_produtos_por_relatorio" hide-details class="mr-3">
            <template #label>
              <span class="ml-1">Todos os produtos em cada relatório</span>
            </template>
          </v-checkbox>

          <SysBotao class="mr-3" background="white" @click="DIALOG_ATIVO = false">
            Cancelar
          </SysBotao>

          <form
            :action="relatorioSelecionado.url"
            method="post"
            target="_blank"
          >
            <input type="text" hidden name="id_pedido" :value="pedido.id" />
            <input type="text" hidden name="todos_os_produtos_por_relatorio" :value="todos_os_produtos_por_relatorio ? 'S' : 'N'" />
            <input type="text" hidden name="fornecedores" :value="JSON.stringify(fornecedores_selecionados)" />

            <SysBotao
              v-if="fornecedores_selecionados.length > 0"
              type="submit"
              background="#142454"
              color-texto="white"
              class="font-16"
              radius="8"
              v-text="`Gerar ${fornecedores_selecionados.length} Cotações`"
              @click="abrirDialogResultadoCotacao"
            />

            <SysBotao
              v-else
              background="rgba(0, 0, 0, 0.16)"
              color-texto="rgba(0, 0, 0, 0.16)"
              class="font-16"
              radius="8"
              disabled
              v-text="'Gerar Cotações'"
            />
          </form>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SysBotao from "../../../../../utils/botoes/SysBotao";
import RelatoriosAutocomplete from "./RelatoriosAutocomplete.vue";
import FornecedoresPorCotar from "./Fornecedores/Index.vue";
import MarcasASeremCotadas from '../../../../departamentos/carrinho/cotacao/MarcasASeremCotadas.vue';

export default {
  name: "GerarCotacao",
  components: {
    SysBotao,
    RelatoriosAutocomplete,
    FornecedoresPorCotar,
    MarcasASeremCotadas
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: Boolean,
    desabilitar: Boolean,
    pedido: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    relatorioSelecionado: {},
    fornecedores_selecionados: [],
    todos_os_produtos_por_relatorio: false
  }),
  computed: {
    DIALOG_ATIVO: {
      get: function () {
        return this.modelValue;
      },
      set: function (value) {
        this.$emit("update:modelValue", value);
      }
    }
  },
  methods: {
    abrirDialogGerarCotacao() {
      if (this.desabilitar) return;
      this.DIALOG_ATIVO = true;
    },
    abrirDialogResultadoCotacao() {
      this.$emit('gerou-cotacao', {});
    }
  }
}
</script>

<style scoped>
#btn-finalizar-compra {
  padding: 1px 15px;
  font-weight: 400;
}
.border-r {
  border-right: 1px solid #e0e0e0;
}
</style>
